export function parsePriceFormatted(priceFormatted: string | null): {
  isFree: boolean;
  priceFinal: number | null;
} {
  const isFree = !priceFormatted || priceFormatted === "Free";

  if (isFree || !priceFormatted) {
    return {
      isFree,
      priceFinal: null,
    };
  }

  const priceValue = parseFloat(priceFormatted.replace(/[^0-9.]/g, ""));
  const priceFinal = priceValue ? Math.round(priceValue * 100) : null;

  return {
    isFree,
    priceFinal,
  };
}
